var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 9.999,
    viewBox: "0 0 14 9.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#04bf2a;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.752,16.659a1,1,0,0,1-1.376.122l-5-4a1,1,0,1,1,1.248-1.562l4.253,3.4,6.371-7.281a1,1,0,0,1,1.5,1.318Z",
    transform: "translate(-5 -7.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.92c0d9868597415590a9165db904138c.svg";
export { ForwardRef as ReactComponent };